class ProductTabsComponent extends HTMLElement {
    constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.tabButtons = document.querySelectorAll(`#shopify-section-${this.sectionId} .product-tabs__btn`);
        this.panels = this.querySelectorAll('[data-tab-panel]');
        this.viewAllLink = document.querySelector(`#shopify-section-${this.sectionId} .js-tabs-view-all`);

        this.tabButtons.forEach((btn) => {
            btn.addEventListener('click', () => this.activateTab(btn));
        });
    }

    activateTab(activeBtn) {
        const index = activeBtn.dataset.tabIndex;

        this.tabButtons.forEach((btn) => {
            const isActive = btn === activeBtn;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
            const isActive = panel.dataset.tabPanel === index;
            panel.classList.toggle('hidden', !isActive);

            if (isActive && this.viewAllLink) {
                const url = panel.dataset.collectionUrl;
                if (url) {
                    this.viewAllLink.setAttribute('href', url);
                }
            }
        });
    }
}

customElements.define('product-tabs-component', ProductTabsComponent);


function initProductTabsScrollbar(wrap) {
    if (wrap.dataset.scrollbarInit === 'true') return;
    wrap.dataset.scrollbarInit = 'true';

    const track = wrap.querySelector('.product-tabs-scrollbar');
    const thumb = wrap.querySelector('.product-tabs-scrollbar__thumb');
    const tabs = wrap.querySelector('.product-tabs');

    if (!track || !thumb || !tabs) return;

    function update() {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        const scrollable = isMobile && tabs.scrollWidth - tabs.clientWidth > 1;

        track.classList.toggle('is-hidden', !scrollable);
        track.style.display = isMobile ? (scrollable ? 'block' : 'none') : '';

        if (!scrollable) return;

        const thumbWidthRatio = tabs.clientWidth / tabs.scrollWidth;
        const maxScroll = tabs.scrollWidth - tabs.clientWidth;
        const scrollRatio = maxScroll > 0 ? tabs.scrollLeft / maxScroll : 0;

        const trackWidth = track.clientWidth;
        const thumbWidth = Math.max(thumbWidthRatio * trackWidth, 24);
        const thumbOffset = scrollRatio * (trackWidth - thumbWidth);

        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${thumbOffset}px)`;
    }

    tabs.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => update());
        resizeObserver.observe(tabs);
    }

    window.addEventListener('load', update);
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(update);
    }

    update();
    requestAnimationFrame(update);
}

function initAllProductTabsScrollbars(root = document) {
    root.querySelectorAll('.product-tabs-wrap').forEach((wrap) => initProductTabsScrollbar(wrap));
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllProductTabsScrollbars());
} else {
    initAllProductTabsScrollbars();
}

document.addEventListener('shopify:section:load', (event) => {
    initAllProductTabsScrollbars(event.target);
});